export default {
    path : "land-item-recycled",
    name : "land-item-recycled",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/land/recycled/Index'),
    redirect: {
        name : "land-item-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-item-recycled-whole',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-item-recycled-recent',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-item-recycled-atme',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-item-recycled-meat',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-item-recycled-reply',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'land-item-recycled-search',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/recycleditem/index.js